<script setup lang="ts">
import IconQuestion from "~/components/sx/icons/hero/IconQuestion.vue";
import IconBrasil from "~/components/sx/icons/hero/IconBrasil.vue";
import IconPhone from "~/components/sx/icons/hero/IconPhone.vue";
import IconGlobeGreen from "~/components/sx/icons/IconGlobeGreen.vue";
import IconFacebook from "~/components/sx/icons/social/IconFacebook.vue";
import IconYoutube from "~/components/sx/icons/social/IconYoutube.vue";
import IconTwitch from "~/components/sx/icons/social/IconTwitch.vue";
import IconVkontakte from "../sx/icons/social/IconVkontakte.vue";
import IconSpotify from "~/components/sx/icons/social/IconSpotify.vue";
import IconInstagram from "~/components/sx/icons/social/IconInstagram.vue";
import IconTikTok from "~/components/sx/icons/social/IconTikTok.vue";
import IconTwitter from "~/components/sx/icons/social/IconTwitter.vue";
import IconPinterest from "~/components/sx/icons/social/IconPinterest.vue";
import IconBubble from "~/components/sx/icons/IconBubble.vue";
import {UiIcon, UiTooltip} from '@common/ui-kit';
import RatingTooltipContent from "~/components/hero/tooltipContents/RatingTooltipContent.vue";
import IconCaretDown from "~/components/sx/icons/IconCaretDown.vue";
import { useWindowSize } from "@vueuse/core";
import IconCloud from "~/components/sx/icons/IconCloud.vue";
import {capitalize} from "vue";

const { t } = useI18n();
const { width } = useWindowSize();

const socials = [
  {
    title: 'Facebook',
    icon: markRaw(IconFacebook)
  },
  {
    title: 'YouTube',
    icon: markRaw(IconYoutube)
  },
  {
    title: 'VKontakte',
    icon: markRaw(IconVkontakte)
  },
  {
    title: 'Twitch',
    icon: markRaw(IconTwitch)
  },
  {
    title: 'Spotify',
    icon: markRaw(IconSpotify)
  },
  {
    title: 'Instagram',
    icon: markRaw(IconInstagram)
  },
  {
    title: 'TikTok',
    icon: markRaw(IconTikTok)
  },
  {
    title: 'Twitter',
    icon: markRaw(IconTwitter)
  },
  {
    title: 'Pinterest',
    icon: markRaw(IconPinterest)
  },
]

const proxyTypes = [
  {
    titleKey: 'components.proxyProperties.proxyTypes.mobile.title',
    textKey: 'components.proxyProperties.proxyTypes.mobile.description',
  },
  {
    titleKey: 'components.proxyProperties.proxyTypes.resident.title',
    textKey: 'components.proxyProperties.proxyTypes.resident.description',
  },
  {
    titleKey: 'components.proxyProperties.proxyTypes.corporate.title',
    textKey: 'components.proxyProperties.proxyTypes.corporate.description',
  },
];
</script>

<template>
  <div class="proxy-properties">
    <div class="proxy-properties__inner">
      <div class="proxy-properties__border">
        <div class="proxy-properties__table">
          <div class="proxy-properties__header">
            <div class="proxy-properties__header-item relative">
              <UiTooltip
                popperClass="custom-tooltip"
                :position="width > 700 ? 'right-start' : 'bottom-start'"
                :title="capitalize($t('components.proxyProperties.rating.title'))"
                class="bubble"
              >
                <template #text>
                  <RatingTooltipContent />
                </template>
                <div>
                  <IconBubble />
                  <div class="bubble-text">
                    {{ capitalize($t('components.proxyProperties.rating.question')) }}
                  </div>
                </div>
              </UiTooltip>
              <div class="proxy-properties__tag default-tag">
                <div class="proxy-properties__tag-inner">
                  5.0
                </div>
              </div>
            </div>
            <div class="proxy-properties__header-item">
              <div class="ellipsis">
                proxy-server-xyz.com:8080
              </div>
            </div>
            <div class="proxy-properties__header-item">
              <div>
                47.236.161.323.11
              </div>
            </div>
            <div class="proxy-properties__header-item">
              <div class="type">
                <icon-brasil />
                Brazil, Campinas
              </div>
            </div>
            <div class="proxy-properties__header-item relative">
              <div class="type">
                <icon-phone />
                <div class="default-tag">
                  {{ $t('components.proxyProperties.mobile') }}
                </div>
                <div class="proxy-properties__tag default-tag sm">
                  <div class="proxy-properties__item-header-inner">
                    <UiTooltip
                      position="bottom"
                      class="bubble cloud"
                      :title="capitalize($t('components.proxyProperties.proxyTypes.title'))"
                      popperClass="custom-tooltip sm"
                    >
                      <template #text>
                        <div class="tooltip-column">
                          <div v-for="item in proxyTypes" class="tooltip-inner">
                            <strong>
                              {{ capitalize($t(item.titleKey)) }}
                            </strong>
                            <div class="gray">
                              {{ capitalize($t(item.textKey)) }}
                            </div>
                          </div>
                        </div>
                      </template>
                      <div>
                        <IconCloud />
                        <div class="bubble-text">
                          {{ capitalize($t('components.proxyProperties.proxyTypes.question')) }}
                        </div>
                      </div>
                    </UiTooltip>
                    +1
                  </div>
                </div>
              </div>
            </div>
            <div class="proxy-properties__header-item">
              <div class="green">
                0/318
              </div>
            </div>  <div class="proxy-properties__header-item">
            <div class="green">
              12/12
            </div>
          </div>
            <div class="proxy-properties__header-item">
              <IconCaretDown />
            </div>
          </div>
          <div class="proxy-properties__content">
            <div class="proxy-properties__subtitle">
              {{ capitalize($t('components.proxyProperties.servicesInfo')) }}
            </div>
            <div class="proxy-properties__list">
              <div class="proxy-properties__item sm">
                <div class="proxy-properties__item-header default-tag">
                  {{ capitalize($t('components.proxyProperties.main.title')) }}
                  <UiTooltip
                    position="bottom"
                    :title="capitalize($t('components.proxyProperties.main.title'))"
                    :text="$t('components.proxyProperties.main.tooltip')"
                  >
                    <IconQuestion />
                  </UiTooltip>
                </div>
                <div class="proxy-properties__item-inner">
                  <div class="green">
                    HTTP {{ $t('components.proxyProperties.main.protocol') }}
                  </div>
                  <div class="green">
                    SOCKS5 {{ $t('components.proxyProperties.main.protocol') }}
                  </div>
                  <div class="divider" />
                  <div class="footer">
                    <div class="green">
                      {{ capitalize($t('components.proxyProperties.main.responseTime')) }}
                    </div>
                    <div class="proxy-properties__tag sm">
                      1.99 s
                    </div>
                  </div>
                </div>
              </div>

              <div class="proxy-properties__item flex">
                <div class="proxy-properties__item-header default-tag">
                  {{ capitalize($t('components.proxyProperties.blacklists.title')) }}

                  <div class="proxy-properties__item-header-inner relative">
                    <UiTooltip
                      :position="width > 700 ? 'left-center' : 'bottom-start'"
                      class="bubble right"
                      :title="capitalize($t('components.proxyProperties.blacklists.question'))"
                      popperClass="custom-tooltip sm"
                    >
                      <template #text>
                        <div class="tooltip-inner">
                          {{ $t('components.proxyProperties.blacklists.tooltip') }}
                        </div>
                      </template>
                      <div>
                        <IconBubble />
                        <div class="bubble-text">
                          {{ capitalize($t('components.proxyProperties.blacklists.title')) }}
                        </div>
                      </div>
                    </UiTooltip>
                    <IconQuestion />
                  </div>
                </div>
                <div class="proxy-properties__item-inner">
                  <div class="globe">
                    <IconGlobeGreen />
                  </div>
                  <div class="text">
                    {{ capitalize($t('components.proxyProperties.blacklists.notFound')) }}
                    <div class="gray">
                      +{{ $t('components.proxyProperties.blacklists.ratingBonus') }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="proxy-properties__item">
                <div class="proxy-properties__item-header default-tag">
                  {{ capitalize($t('components.proxyProperties.services.title')) }}
                  <div class="proxy-properties__item-header-inner relative">
                    <UiTooltip
                      position="top"
                      class="bubble right"
                      :title="capitalize($t('components.proxyProperties.services.question'))"
                      popperClass="custom-tooltip sm"
                    >
                      <template #text>
                        <div class="tooltip-inner">
                          {{ $t('components.proxyProperties.services.tooltip') }}
                        </div>
                      </template>
                      <div>
                        <IconBubble />
                        <div class="bubble-text">
                          {{ capitalize($t('components.proxyProperties.services.title')) }}
                        </div>
                      </div>
                    </UiTooltip>
                    <IconQuestion />
                  </div>
                </div>
                <div class="proxy-properties__item-inner social-list">
                  <div v-for="(item, index) in socials" :key="index" class="social">
                    <component :is="item.icon" />
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="proxy-properties__info">
      <div class="proxy-properties__service">
        <div class="proxy-properties__service-icon">
          <UiIcon
            name="done"
            type="400"
            size="lg"
          />
        </div>
        <p class="proxy-properties__service-text proxy-properties__service-description">
          {{ capitalize($t('components.proxyProperties.checkerService')) }}
        </p>
        <div class="proxy-properties__service-divider" />
        <div class="proxy-properties__service-text proxy-properties__service-title">
          <a href="https://checker.net" target="_blank" class="proxy-properties__service-link default-tag">
            https://checker.net
            <UiIcon
              name="new-windows"
              type="400"
              size="lg"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.custom-tooltip {
  max-height: 600px;
  .ui-tooltip__content {
    min-height: max-content;
    height: 600px;
    .ui-tooltip__content-inner {
      max-height: inherit;
    }
  }
  &.sm {
    max-height: inherit;
    .ui-tooltip__content {
      min-height: inherit;
      height: auto;
    }
  }
}
.tooltip-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.tooltip-inner {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  .gray {
    color: #A4A5B1;
    font-weight: 300;
  }
}
.proxy-properties {
  outline: var(--border-sx-main);
  background: var(--bg-sx-lightblue);
  padding: 20px;
  max-width: 1170px;
  width: 100%;
  border-radius: 20px;
  @media (max-width: 767px) {
    padding: 1rem;
  }
  &__info {
    margin-top: 16px;
    padding-inline: 32px;
    @media (max-width: 767px) {
      padding: 0;
    }
  }
  &__service {
    display: flex;
    align-items: center;
    gap: 8px;
    border: var(--border-sx-main);
    border-radius: 50px;
    background: white;
    padding: 10px 24px 10px 12px;
    @media (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
      border-radius: 24px;
    }
    &-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      min-width: 36px;
      height: 36px;
      background: #2185EA33;
      border-radius: 50%;
    }
    &-text {
      display: inline-block;
      background: linear-gradient(90deg, #4796E6 0%, #3576B9 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      background-size: 200% 100%;
      animation: gradient-slide 1s ease-in-out infinite alternate;
      will-change: background-position;
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      @media (max-width: 767px) {
        font-size: 16px;
        line-height: 18px;
      }
    }
    &-divider {
      height: auto;
      align-self: stretch;
      border-right: var(--border-sx-main);
    }
    &-link {
      display: flex;
      align-items: center;
      gap: 8px;
      text-transform: uppercase;
      &:hover {
        box-shadow: 0 2px 0 0 #4796E6;
      }
    }
  }
  &__inner {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
  }
  &__title {
    text-align: center;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0;
    max-width: 856px;
    @media (max-width: 1279px) {
      margin-left: 120px;
    }
    @media (max-width: 499px) {
      margin-left: 0;
      margin-bottom: 80px;
    }
  }
  &__border {
    width: 100%;
    padding: 16px;
    border: var(--border-sx-main);
    border-radius: 16px;
    background: white;
  }
  &__table {
    outline: var(--border-sx-main);
    width: 100%;
  }
  &__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    min-height: 48px;
    padding-block: 4px;
    border-bottom: var(--border-sx-main);
    &-item {
      padding: 0 12px;
      &.relative {
        position: relative;
      }

      .type {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .green {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0;
        color: var(--font-sx-color-darkgreen)
      }
      .ellipsis {
        max-width: 158px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  &__tag {
    background: var(--bg-sx-green);
    border-radius: 6px;
    padding: 0 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 12px;
    letter-spacing: 0;
    height: 20px;
    color: #fff;
    &.sm {
      background: #E6FAED;
      color: var(--font-sx-color-green);
      height: 16px;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0;
      border-radius: 4px;
      padding: 0 6px;
      min-width: 40px;
      text-decoration: none;
      cursor: default;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &-inner {
      line-height: 1;
      font-size: inherit;
    }
  }
  &__content {
    padding: 14px 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: var(--bg-sx-lightblue);
  }
  &__subtitle {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    color: var(--font-sx-primary)
  }
  &__list {
    align-items: stretch;
    display: grid;
    grid-template-columns: 0.7fr 0.7fr 1.6fr;
    gap: 24px;
    @media (max-width: 1099px) {
      display: flex;
      flex-wrap: wrap;
    }
  }
  &__item {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 8px;
    min-width: 238px;
    &.flex {
      display: flex;
      align-items: center;
      :deep(.flex) {
        display: flex;
        justify-content: center;
      }
    }
    &.sm {
      max-width: 240px;
      min-width: 240px;
    }
    @media (max-width: 499px) {
      min-width: 200px;
    }
    &-inner {
      display: flex;
      flex-direction: column;
      gap: 8px;
      .globe {
        display: flex;
        justify-content: center;
      }
      .text {
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0;
        .gray {
          color: #6B6D80;
          font-weight: 400;
        }
      }
      .green {
        font-weight: 400;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 0;
        text-decoration: underline;
        text-decoration-style: dashed;
        color: var(--font-sx-color-green)
      }
      .divider {
        border-bottom: var(--border-sx-main);
      }
      .footer {
        display: flex;
        align-items: center;
        gap: 4px;
        .green {
          font-size: 12px;
        }
      }
      &.social-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        row-gap: 16px;
        column-gap: 20px;
        @media (max-width: 599px) {
          gap: 8px;
          max-width: 230px;
        }
        .social {
          display: flex;
          align-items: center;
          gap: 4px;
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
          letter-spacing: 0;
          text-decoration: underline;
          color: var(--font-sx-color-green);
        }
      }
    }
    &-header {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0;
      color: var(--font-sx-color-gray);
      align-items: center;
      display: flex;
      gap: 4px;
      &-inner {
        &.relative {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      svg {
        cursor: pointer;
        &:hover {
          color: #000
        }
      }
    }
    &-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0;
    }
  }
}

.bubble {
  position: absolute;
  bottom: 12px;
  left: 0;
  transform: translateX(-50%);
  cursor: pointer;
  @media (max-width: 1279px) {
    transform: translateX(-40%);
  }
  &.right {
    right: -40px;
    left: auto !important;
    transform: none !important;
  }
  &.cloud {
    transform: none !important;
    left: 50%;
    .bubble-text {
      top: 50%;
      white-space: nowrap;
      left: 50%;
      transform: translate(-28%, -78%);
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .bubble-text {
    color: black;
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(30%, 35%);
    max-width: 100px;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0;
    text-align: center;
    text-decoration: underline;
    text-decoration-style: dashed;
    text-underline-offset: 4px;
  }
}
</style>